<a class="logo" [routerLink]="['/home'] | localize">
    <img class="logo-img" src="/assets/images/logo-small.png" alt="" />
    <img class="logo-title" *ngIf="isMenuOpen$ | async" src="/assets/images/logo-text.png" alt="{{ 'MAIN.TITLE' | translate }}">
</a>
